import React, { useState } from "react";
import { FaHeart, FaRegCommentDots, FaShare } from "react-icons/fa";
import { abbreviateNumber } from "utility";
import { ContentType } from "utility/constants";
import DownloadTheAppModal from "components/modals/DownloadTheAppModal";
import ShareLinksModal from "components/modals/ShareLinksModal";
import { GoUnmute, GoMute } from "react-icons/go";
import { useVideoPlayerStore } from "hooks/useVideoControls";

export default function PostSideBar({ post }) {
  const [downloadAppModalOpen, setDownloadAppModalOpen] = useState(false);
  const [shareLinksModal, setShareLinksModal] = useState(false);
  const muted = useVideoPlayerStore((state) => state.muted);
  const mute = useVideoPlayerStore((state) => state.mute);
  const unMute = useVideoPlayerStore((state) => state.unMute);

  const OpenModal = () => setDownloadAppModalOpen(true);
  return (
    <>
      <DownloadTheAppModal
        setDownloadAppModalOpen={setDownloadAppModalOpen}
        downloadAppModalOpen={downloadAppModalOpen}
      />
      <ShareLinksModal
        title="Share this snack"
        shareUrl={`${process.env.NEXT_PUBLIC_SNACKTIME_PUBLIC_WEB_URL}/post/${post.id}`}
        setShareLinksModal={setShareLinksModal}
        shareLinksModal={shareLinksModal}
      />
      {post.contentType === ContentType.VIDEO ? (
        <div className="hidden lg:flex absolute right-0 bottom-0 p-4">
          <div className="mb-2 p-2 flex justify-center">
            {muted ? (
              <div onClick={() => unMute()} aria-hidden>
                <GoMute className="text-5xl text-white cursor-pointer z-20 " />
              </div>
            ) : (
              <div onClick={() => mute()} aria-hidden>
                <GoUnmute className="text-5xl text-white cursor-pointer z-20" />
              </div>
            )}
          </div>
        </div>
      ) : null}

      <div className="lg:hidden h-full absolute right-1 w-20 flex flex-col justify-end py-3 z-10">
        {post.contentType === ContentType.VIDEO ? (
          <div className="mb-2 p-2 flex justify-center">
            {muted ? (
              <div onClick={() => unMute()} aria-hidden>
                <GoMute className="text-4xl text-white cursor-pointer z-20 " />
              </div>
            ) : (
              <div onClick={() => mute()} aria-hidden>
                <GoUnmute className="text-4xl text-white cursor-pointer z-20" />
              </div>
            )}
          </div>
        ) : null}

        <div className="flex flex-col items-center justify-center my-2">
          <div
            className="w-10 h-10 bg-gray-100 p-2 rounded-full flex items-center justify-center mb-1"
            aria-hidden
            onClick={OpenModal}
          >
            <FaHeart className="h-full w-full" />
          </div>
          <span className="text-shadow-text text-white">
            {abbreviateNumber(post.likeCount)}
          </span>
        </div>

        <div className="flex flex-col items-center justify-center my-2">
          <div
            className="w-10 h-10 bg-gray-100 p-2 rounded-full flex items-center justify-center mb-1"
            aria-hidden
            onClick={OpenModal}
          >
            <FaRegCommentDots className="h-full w-full" />
          </div>
          <span className="text-shadow-text text-white">
            {abbreviateNumber(post.commentCount)}
          </span>
        </div>

        <div className="flex flex-col items-center justify-center my-2">
          <div
            className="w-10 h-10 bg-gray-100 p-2 rounded-full flex items-center justify-center "
            aria-hidden
            onClick={setShareLinksModal}
          >
            <FaShare className="h-full w-full" />
          </div>
        </div>
      </div>
    </>
  );
}
